// extracted by mini-css-extract-plugin
module.exports = {"footer1":"Footer_footer1__2NQsP","footer-bottom":"Footer_footer-bottom__1RYBB","pull-left":"Footer_pull-left__3FY80","pull-right":"Footer_pull-right__3tOBZ"};